import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import { getImageApi } from 'src/api/apiGetImage';
import { modifyURL } from 'src/const/contain';
import useQueryApi from 'src/hooks/useApiQuery';
import useIsMobile from 'src/hooks/useIsMobile';
import { contentfulSelector } from 'src/redux/selectors/contentfulSelector';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';

const Banner: React.FC = () => {
    const isMobile: boolean = useIsMobile();
    const { productQuote = {} } = useSelector(quoteDetailSelector);
    const { code } = productQuote;
    const {
        ukIrelandCampaignBanner,
        europeCampaignBanner,
        restOfWorldCampaignBanner,
        eventCampaignBanner,
        ukIrelandCampaignBannerMobile,
        europeCampaignBannerMobile,
        restOfWorldCampaignBannerMobile,
        eventCampaignBannerMobile,
    } = useSelector(contentfulSelector);

    const getImageId = (codeQuote: string) => {
        let imageField = isMobile
            ? europeCampaignBannerMobile
            : europeCampaignBanner;
        switch (codeQuote) {
            case 'YGTUKI':
                imageField = isMobile
                    ? ukIrelandCampaignBannerMobile
                    : ukIrelandCampaignBanner;
                break;
            case 'YGTTE':
                imageField = isMobile
                    ? eventCampaignBannerMobile
                    : eventCampaignBanner;
                break;
            case 'YGTROW':
                imageField = isMobile
                    ? restOfWorldCampaignBannerMobile
                    : restOfWorldCampaignBanner;
                break;
            default:
                imageField = isMobile
                    ? europeCampaignBannerMobile
                    : europeCampaignBanner;
                break;
        }

        return imageField?.sys?.id || '';
    };

    const { data: imageField } = useQueryApi(
        ['image', getImageId(code)],
        () => getImageApi(getImageId(code)),
        {
            enabled: code && !!getImageId(code),
        },
    );

    const addHttpsImage = (url: string) => {
        if (url) {
            return `http:${url}`;
        }
        return '';
    };

    const bannerImage = addHttpsImage((imageField as any)?.fields?.file?.url);

    return (
        <>
            {!!getImageId(code) && (
                <div className="banner">
                    {bannerImage ? (
                        <img
                            alt="Banner"
                            src={modifyURL(bannerImage, isMobile ? 600 : 1600)}
                            className="img-banner"
                        />
                    ) : (
                        <Skeleton.Image
                            active={true}
                            className="skeleton-image"
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default Banner;
